import { filterXSS } from "xss";

const whiteList = {
  a: ["href", "title", "target", "class"],
  p: ["class"],
  span: ["class"],
  br: [],
};

export const safeHTML = (html: string) => {
  return {
    __html: filterXSS(html, {
      whiteList,
    }),
  };
};
